import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { CompanyGovernmentAllocationSummaryData } from '@/features/privateCompanies/types/companyGovernmentAllocationSummary.type'
import { useQuery } from '@tanstack/react-query'

type UseCompanyGovernmentAllocationSummaryProps<T> = {
  governmentAllocationId: string
  mapper?: (data: any) => T
}

export const useCompanyGovernmentAllocationSummary = <T,>({
  governmentAllocationId,
  mapper = Mapper.default<T>(),
}: UseCompanyGovernmentAllocationSummaryProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse(), ...rest } = useQuery({
    queryKey: ['companyGovernmentAllocationSummary', governmentAllocationId],
    queryFn: () =>
      privateAxios.get(`/billing/government_allocations/${governmentAllocationId}/summary_of_consumed_and_distributed`),
    select: (data: { data: { data: CompanyGovernmentAllocationSummaryData; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
  })

  return {
    data,
    meta,
    ...rest,
  }
}
